export default "__VITE_ASSET__DOEK33e5__"